import { Suspense } from 'react'
import { observer } from 'mobx-react'

import ErrorBoundaryWithRouter from 'Components/ErrorBoundary/ErrorBoundaryWithRouter'
import { Footer } from 'Components/Footer/Footer'
import { LeftSidebar } from 'Components/LeftSidebar/LeftSidebar'
import { PageLoadingState } from 'Components/PageLoadingState/PageLoadingState'
import { ScrollToTop } from 'Components/ScrollToTop/ScrollToTop'
import { Topbar } from 'Components/Topbar/Topbar'

import type { AuthorisedLayoutProps } from './AuthorisedLayout.types'

export const AuthorisedLayout = observer((props: AuthorisedLayoutProps) => {
  const { children } = props

  return (
    <div>
      <ScrollToTop />

      <Topbar />

      <Suspense fallback={<PageLoadingState />}>
        <LeftSidebar />
      </Suspense>

      <main className="page">
        <div className="wrapper">
          <ErrorBoundaryWithRouter>
            {children}

            <Footer />
          </ErrorBoundaryWithRouter>
        </div>
      </main>
    </div>
  )
})
